/* Category Grid HH — stagger fade-in on scroll */
(function(){
  'use strict';
  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('.hh-cgrid__card').forEach(el => el.classList.add('is-visible'));
    return;
  }
  function init(){
    document.querySelectorAll('.hh-cgrid').forEach(grid => {
      const cards = grid.querySelectorAll('.hh-cgrid__card');
      const io = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const idx = Array.from(cards).indexOf(entry.target);
            entry.target.style.transitionDelay = (idx % 8) * 60 + 'ms';
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -30px 0px' });
      cards.forEach(c => io.observe(c));
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
  document.addEventListener('shopify:section:load', init);
})();
